import pureLogo from "./assets/pure-logo.png"
import border from "./assets/success-border.svg"
import { Button } from "./button"
import { generateAppsFlyerLink } from "lib/common"

interface Props {
  surveyId: string
}

export function Paygate2ScreenSuccess({ surveyId }: Props) {
  return (
    <div className="max-w-full w-dvw min-h-dvh flex flex-col text-white">
      <div className="bg-black pt-[60px] flex justify-center relative">
        <img
          src={pureLogo}
          width={236}
          height={226}
          className="-rotate-[8deg] ml-10 z-[2]"
        />
        <div
          className="absolute bottom-0 left-0 w-full h-[239px] bg-no-repeat bg-left-top bg-[length:auto_100%] z-[1]"
          style={{ backgroundImage: `url(${border})` }}
        />
      </div>
      <div className="bg-violet-190 grow px-8 pt-10 pb-10">
        <h1 className="font-quirk text-[32px] leading-[40px] tracking-[0.5px] -rotate-[7deg] max-w-[230px] mb-8">
          Thank you for your purchase!
        </h1>
        <p className="text-[18px] leading-[24px] rotate-[3deg] text-right mb-7">
          Download the app below to start your dating journey!
        </p>
        <Button
          theme="white"
          className="w-[250px] -rotate-[3deg] mb-6"
          onClick={() => {
            location.assign(generateAppsFlyerLink(surveyId, true))
          }}
        >
          Download Pure
        </Button>
        <div className="text-xs max-w-[250px] mx-auto -rotate-[1deg]">
          Having trouble logging in? Contact our friendly support team{" "}
          <a href="mailto:feedback@pure.app">feedback@pure.app</a>
        </div>
      </div>
    </div>
  )
}
